<script lang="ts">
import { defineComponent, PropType } from "vue";
import config from "@/config";
import KlereoIcon from "@/shared/components/KlereoIcon.vue";

export default defineComponent({
  components: { KlereoIcon },
  data() {
    return {
      captchaUrl: config.captchaUrl,
      rand: Math.random(),
    };
  },
  methods: {
    doRefresh() {
      this.rand = Math.random();
    },
  },
  watch: {
    refresh() {
      this.doRefresh();
    },
  },
  props: {
    refresh: {
      type: Object as PropType<unknown>,
      required: false,
    },
  },
});
</script>

<template>
  <div class="flex gap-2">
    <img :src="`${captchaUrl}?${rand}`" alt="Captcha" />
    <klereo-icon class="cursor-pointer" name="refresh" @click="doRefresh" />
  </div>
</template>
